"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalOrderLinesValue = void 0;
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const getTotalOrderLinesValue = (order_lines) => {
    if (!order_lines)
        return 0;
    if (order_lines.length === 0)
        return 0;
    return order_lines.reduce((acc, cur) => {
        return acc + (0, getOrderLineTotal_1.getOrderLineTotal)(cur);
    }, 0);
};
exports.getTotalOrderLinesValue = getTotalOrderLinesValue;
